/**
 * Phase 17 Plan 17-02 — KpiUnitDisplay
 *
 * Small presentational component that maps a KpiUnit + optional customUnitText
 * to a human-readable string. Used in:
 *  - KPI tab table (unit column)
 *  - EditKpiDialog header
 *  - DeactivateKpiConfirmDialog body
 *  - Maker wizard KPI field labels (Task 2)
 *
 * When unit === 'Custom', shows customUnitText (or falls back to 'Custom').
 * Otherwise shows the unit label from KPI_UNIT_LABELS.
 */

import type { JSX } from 'react';

import { KPI_UNIT_LABELS, type KpiUnit } from '@/types/kpi';

export interface KpiUnitDisplayProps {
  readonly unit: KpiUnit;
  readonly customUnitText: string | null;
}

export function KpiUnitDisplay({ unit, customUnitText }: KpiUnitDisplayProps): JSX.Element {
  const label =
    unit === 'Custom'
      ? (customUnitText !== null && customUnitText !== '' ? customUnitText : 'Custom')
      : KPI_UNIT_LABELS[unit];

  return <span>{label}</span>;
}

/** Pure function version — useful for table cell content where JSX is not needed. */
// eslint-disable-next-line react-refresh/only-export-components -- helper kept beside its component pair for cohesion (Phase 17 D-160).
export function formatKpiUnit(unit: KpiUnit, customUnitText: string | null): string {
  if (unit === 'Custom') {
    return customUnitText !== null && customUnitText !== '' ? customUnitText : 'Custom';
  }
  return KPI_UNIT_LABELS[unit];
}
